export default __webpack_public_path__ + "static/media/form_manut.47c1c655.gif";